import { useRegion, REGION_LIST } from "@/lib/region";

export const RegionToggle = ({ compact = false, testid = "region-toggle" }) => {
  const { region, setRegion } = useRegion();
  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full border border-white/10 bg-black/40 p-1 ${compact ? "text-xs" : "text-sm"}`}
      data-testid={testid}
    >
      {REGION_LIST.map(r => {
        const active = region === r.id;
        return (
          <button
            key={r.id}
            type="button"
            onClick={() => setRegion(r.id)}
            data-testid={`region-btn-${r.id}`}
            className={`px-4 ${compact ? "py-1" : "py-2"} rounded-full transition font-medium tracking-wide ${
              active ? "bg-[#D4AF37] text-black" : "text-zinc-300 hover:text-white"
            }`}
          >
            <span className="mr-1.5">{r.flag}</span>
            {compact ? r.code : r.label}
          </button>
        );
      })}
    </div>
  );
};

export default RegionToggle;
